export const GETPRODUCTLAPTOPDATA_REQUEST = 'GETPRODUCTLAPTOPDATA_REQUEST' 
export const GETPRODUCTLAPTOPDATA_SUCCESS = 'GETPRODUCTLAPTOPDATA_SUCCESS' 
export const GETPRODUCTLAPTOPDATA_FAILURE = 'GETPRODUCTLAPTOPDATA_FAILURE ' 



